"use client";

import { useEffect } from "react";

import { useParams, useRouter } from "next/navigation";

import { useHomeRoute } from "@/hooks/use-home-route";

/**
 * The tenant root, `/{tenant}`. Login sends single-clinic staff here instead of
 * reading the home page off `/tenant/select`; the console layout has already
 * loaded the tenant and user by the time this renders, so it knows the home.
 */
export default function TenantRootPage() {
  const router = useRouter();
  const params = useParams();
  const homeRoute = useHomeRoute();
  const tenantSlug = params.tenant as string;

  useEffect(() => {
    router.replace(`/${tenantSlug}${homeRoute}`);
  }, [router, tenantSlug, homeRoute]);

  return null;
}
